module.exports = __webpack_public_path__ + "static/media/Q2_Back_Right.ace0de20.png";